/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Budget } from '../models';
// @ts-ignore
import type { ListBudgetsResponse } from '../models';
// @ts-ignore
import type { PreviewBudgetCostRequest } from '../models';
// @ts-ignore
import type { PreviewBudgetCostResponse } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * BudgetsAPIApi - axios parameter creator
 * @export
 */
export const BudgetsAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Creates a new budget for the organization.
         * @summary Creates a new budget.
         * @param {string} organizationId Organization ID.
         * @param {Budget} budget 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPICreateBudget: async (organizationId: string, budget: Budget, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPICreateBudget', 'organizationId', organizationId)
            // verify required parameter 'budget' is not null or undefined
            assertParamExists('budgetsAPICreateBudget', 'budget', budget)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(budget, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Permanently deletes a budget.
         * @summary Permanently deletes a budget.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIDeleteBudget: async (organizationId: string, budgetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPIDeleteBudget', 'organizationId', organizationId)
            // verify required parameter 'budgetId' is not null or undefined
            assertParamExists('budgetsAPIDeleteBudget', 'budgetId', budgetId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets/{budgetId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"budgetId"}}`, encodeURIComponent(String(budgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a single budget by ID.
         * @summary Returns a budget by ID.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIGetBudget: async (organizationId: string, budgetId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPIGetBudget', 'organizationId', organizationId)
            // verify required parameter 'budgetId' is not null or undefined
            assertParamExists('budgetsAPIGetBudget', 'budgetId', budgetId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets/{budgetId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"budgetId"}}`, encodeURIComponent(String(budgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all of the organization\'s budgets in one call.
         * @summary Returns all of the organization\'s budgets.
         * @param {string} organizationId Organization ID.
         * @param {boolean} [includeDisabled] Include paused (disabled) budgets in the list. Defaults to true.
         * @param {boolean} [includeThresholds] Include thresholds (percent, recipients, alert fire state) in each returned budget if true.  Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIListBudgets: async (organizationId: string, includeDisabled?: boolean, includeThresholds?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPIListBudgets', 'organizationId', organizationId)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (includeDisabled !== undefined) {
                localVarQueryParameter['includeDisabled'] = includeDisabled;
            }

            if (includeThresholds !== undefined) {
                localVarQueryParameter['includeThresholds'] = includeThresholds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the actual cost of a scope over a fixed trailing 30-day window.  Powers the budget create-form tooltip; reads the same cost pipeline the  evaluator compares against. Window is fixed server-side (last 30 days).
         * @summary Returns a scope\'s actual cost over the first viable period of the given window.
         * @param {string} organizationId Organization ID.
         * @param {PreviewBudgetCostRequest} previewBudgetCostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIPreviewBudgetCost: async (organizationId: string, previewBudgetCostRequest: PreviewBudgetCostRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPIPreviewBudgetCost', 'organizationId', organizationId)
            // verify required parameter 'previewBudgetCostRequest' is not null or undefined
            assertParamExists('budgetsAPIPreviewBudgetCost', 'previewBudgetCostRequest', previewBudgetCostRequest)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets:cost-preview`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(previewBudgetCostRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Full replacement.
         * @summary Replaces a budget.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {Budget} budget 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIUpdateBudget: async (organizationId: string, budgetId: string, budget: Budget, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('budgetsAPIUpdateBudget', 'organizationId', organizationId)
            // verify required parameter 'budgetId' is not null or undefined
            assertParamExists('budgetsAPIUpdateBudget', 'budgetId', budgetId)
            // verify required parameter 'budget' is not null or undefined
            assertParamExists('budgetsAPIUpdateBudget', 'budget', budget)
            const localVarPath = `/reporting/v1beta/organizations/{organizationId}/budgets/{budgetId}`
                .replace(`{${"organizationId"}}`, encodeURIComponent(String(organizationId)))
                .replace(`{${"budgetId"}}`, encodeURIComponent(String(budgetId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(budget, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BudgetsAPIApi - functional programming interface
 * @export
 */
export const BudgetsAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BudgetsAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * Creates a new budget for the organization.
         * @summary Creates a new budget.
         * @param {string} organizationId Organization ID.
         * @param {Budget} budget 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPICreateBudget(organizationId: string, budget: Budget, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Budget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPICreateBudget(organizationId, budget, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPICreateBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Permanently deletes a budget.
         * @summary Permanently deletes a budget.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPIDeleteBudget(organizationId: string, budgetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPIDeleteBudget(organizationId, budgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPIDeleteBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a single budget by ID.
         * @summary Returns a budget by ID.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPIGetBudget(organizationId: string, budgetId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Budget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPIGetBudget(organizationId, budgetId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPIGetBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all of the organization\'s budgets in one call.
         * @summary Returns all of the organization\'s budgets.
         * @param {string} organizationId Organization ID.
         * @param {boolean} [includeDisabled] Include paused (disabled) budgets in the list. Defaults to true.
         * @param {boolean} [includeThresholds] Include thresholds (percent, recipients, alert fire state) in each returned budget if true.  Defaults to false.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPIListBudgets(organizationId: string, includeDisabled?: boolean, includeThresholds?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListBudgetsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPIListBudgets(organizationId, includeDisabled, includeThresholds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPIListBudgets']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the actual cost of a scope over a fixed trailing 30-day window.  Powers the budget create-form tooltip; reads the same cost pipeline the  evaluator compares against. Window is fixed server-side (last 30 days).
         * @summary Returns a scope\'s actual cost over the first viable period of the given window.
         * @param {string} organizationId Organization ID.
         * @param {PreviewBudgetCostRequest} previewBudgetCostRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPIPreviewBudgetCost(organizationId: string, previewBudgetCostRequest: PreviewBudgetCostRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PreviewBudgetCostResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPIPreviewBudgetCost(organizationId, previewBudgetCostRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPIPreviewBudgetCost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Full replacement.
         * @summary Replaces a budget.
         * @param {string} organizationId Organization ID.
         * @param {string} budgetId Budget ID.
         * @param {Budget} budget 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async budgetsAPIUpdateBudget(organizationId: string, budgetId: string, budget: Budget, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Budget>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.budgetsAPIUpdateBudget(organizationId, budgetId, budget, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BudgetsAPIApi.budgetsAPIUpdateBudget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BudgetsAPIApi - factory interface
 * @export
 */
export const BudgetsAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BudgetsAPIApiFp(configuration)
    return {
        /**
         * Creates a new budget for the organization.
         * @summary Creates a new budget.
         * @param {BudgetsAPIApiBudgetsAPICreateBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPICreateBudget(requestParameters: BudgetsAPIApiBudgetsAPICreateBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Budget> {
            return localVarFp.budgetsAPICreateBudget(requestParameters.organizationId, requestParameters.budget, options).then((request) => request(axios, basePath));
        },
        /**
         * Permanently deletes a budget.
         * @summary Permanently deletes a budget.
         * @param {BudgetsAPIApiBudgetsAPIDeleteBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIDeleteBudget(requestParameters: BudgetsAPIApiBudgetsAPIDeleteBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.budgetsAPIDeleteBudget(requestParameters.organizationId, requestParameters.budgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a single budget by ID.
         * @summary Returns a budget by ID.
         * @param {BudgetsAPIApiBudgetsAPIGetBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIGetBudget(requestParameters: BudgetsAPIApiBudgetsAPIGetBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Budget> {
            return localVarFp.budgetsAPIGetBudget(requestParameters.organizationId, requestParameters.budgetId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all of the organization\'s budgets in one call.
         * @summary Returns all of the organization\'s budgets.
         * @param {BudgetsAPIApiBudgetsAPIListBudgetsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIListBudgets(requestParameters: BudgetsAPIApiBudgetsAPIListBudgetsRequest, options?: RawAxiosRequestConfig): AxiosPromise<ListBudgetsResponse> {
            return localVarFp.budgetsAPIListBudgets(requestParameters.organizationId, requestParameters.includeDisabled, requestParameters.includeThresholds, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the actual cost of a scope over a fixed trailing 30-day window.  Powers the budget create-form tooltip; reads the same cost pipeline the  evaluator compares against. Window is fixed server-side (last 30 days).
         * @summary Returns a scope\'s actual cost over the first viable period of the given window.
         * @param {BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIPreviewBudgetCost(requestParameters: BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest, options?: RawAxiosRequestConfig): AxiosPromise<PreviewBudgetCostResponse> {
            return localVarFp.budgetsAPIPreviewBudgetCost(requestParameters.organizationId, requestParameters.previewBudgetCostRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Full replacement.
         * @summary Replaces a budget.
         * @param {BudgetsAPIApiBudgetsAPIUpdateBudgetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        budgetsAPIUpdateBudget(requestParameters: BudgetsAPIApiBudgetsAPIUpdateBudgetRequest, options?: RawAxiosRequestConfig): AxiosPromise<Budget> {
            return localVarFp.budgetsAPIUpdateBudget(requestParameters.organizationId, requestParameters.budgetId, requestParameters.budget, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for budgetsAPICreateBudget operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPICreateBudgetRequest
 */
export interface BudgetsAPIApiBudgetsAPICreateBudgetRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPICreateBudget
     */
    readonly organizationId: string

    /**
     * 
     * @type {Budget}
     * @memberof BudgetsAPIApiBudgetsAPICreateBudget
     */
    readonly budget: Budget
}

/**
 * Request parameters for budgetsAPIDeleteBudget operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPIDeleteBudgetRequest
 */
export interface BudgetsAPIApiBudgetsAPIDeleteBudgetRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIDeleteBudget
     */
    readonly organizationId: string

    /**
     * Budget ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIDeleteBudget
     */
    readonly budgetId: string
}

/**
 * Request parameters for budgetsAPIGetBudget operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPIGetBudgetRequest
 */
export interface BudgetsAPIApiBudgetsAPIGetBudgetRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIGetBudget
     */
    readonly organizationId: string

    /**
     * Budget ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIGetBudget
     */
    readonly budgetId: string
}

/**
 * Request parameters for budgetsAPIListBudgets operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPIListBudgetsRequest
 */
export interface BudgetsAPIApiBudgetsAPIListBudgetsRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIListBudgets
     */
    readonly organizationId: string

    /**
     * Include paused (disabled) budgets in the list. Defaults to true.
     * @type {boolean}
     * @memberof BudgetsAPIApiBudgetsAPIListBudgets
     */
    readonly includeDisabled?: boolean

    /**
     * Include thresholds (percent, recipients, alert fire state) in each returned budget if true.  Defaults to false.
     * @type {boolean}
     * @memberof BudgetsAPIApiBudgetsAPIListBudgets
     */
    readonly includeThresholds?: boolean
}

/**
 * Request parameters for budgetsAPIPreviewBudgetCost operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest
 */
export interface BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIPreviewBudgetCost
     */
    readonly organizationId: string

    /**
     * 
     * @type {PreviewBudgetCostRequest}
     * @memberof BudgetsAPIApiBudgetsAPIPreviewBudgetCost
     */
    readonly previewBudgetCostRequest: PreviewBudgetCostRequest
}

/**
 * Request parameters for budgetsAPIUpdateBudget operation in BudgetsAPIApi.
 * @export
 * @interface BudgetsAPIApiBudgetsAPIUpdateBudgetRequest
 */
export interface BudgetsAPIApiBudgetsAPIUpdateBudgetRequest {
    /**
     * Organization ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIUpdateBudget
     */
    readonly organizationId: string

    /**
     * Budget ID.
     * @type {string}
     * @memberof BudgetsAPIApiBudgetsAPIUpdateBudget
     */
    readonly budgetId: string

    /**
     * 
     * @type {Budget}
     * @memberof BudgetsAPIApiBudgetsAPIUpdateBudget
     */
    readonly budget: Budget
}

/**
 * BudgetsAPIApi - object-oriented interface
 * @export
 * @class BudgetsAPIApi
 * @extends {BaseAPI}
 */
export class BudgetsAPIApi extends BaseAPI {
    /**
     * Creates a new budget for the organization.
     * @summary Creates a new budget.
     * @param {BudgetsAPIApiBudgetsAPICreateBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPICreateBudget(requestParameters: BudgetsAPIApiBudgetsAPICreateBudgetRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPICreateBudget(requestParameters.organizationId, requestParameters.budget, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Permanently deletes a budget.
     * @summary Permanently deletes a budget.
     * @param {BudgetsAPIApiBudgetsAPIDeleteBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPIDeleteBudget(requestParameters: BudgetsAPIApiBudgetsAPIDeleteBudgetRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPIDeleteBudget(requestParameters.organizationId, requestParameters.budgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a single budget by ID.
     * @summary Returns a budget by ID.
     * @param {BudgetsAPIApiBudgetsAPIGetBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPIGetBudget(requestParameters: BudgetsAPIApiBudgetsAPIGetBudgetRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPIGetBudget(requestParameters.organizationId, requestParameters.budgetId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all of the organization\'s budgets in one call.
     * @summary Returns all of the organization\'s budgets.
     * @param {BudgetsAPIApiBudgetsAPIListBudgetsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPIListBudgets(requestParameters: BudgetsAPIApiBudgetsAPIListBudgetsRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPIListBudgets(requestParameters.organizationId, requestParameters.includeDisabled, requestParameters.includeThresholds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the actual cost of a scope over a fixed trailing 30-day window.  Powers the budget create-form tooltip; reads the same cost pipeline the  evaluator compares against. Window is fixed server-side (last 30 days).
     * @summary Returns a scope\'s actual cost over the first viable period of the given window.
     * @param {BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPIPreviewBudgetCost(requestParameters: BudgetsAPIApiBudgetsAPIPreviewBudgetCostRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPIPreviewBudgetCost(requestParameters.organizationId, requestParameters.previewBudgetCostRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Full replacement.
     * @summary Replaces a budget.
     * @param {BudgetsAPIApiBudgetsAPIUpdateBudgetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BudgetsAPIApi
     */
    public budgetsAPIUpdateBudget(requestParameters: BudgetsAPIApiBudgetsAPIUpdateBudgetRequest, options?: RawAxiosRequestConfig) {
        return BudgetsAPIApiFp(this.configuration).budgetsAPIUpdateBudget(requestParameters.organizationId, requestParameters.budgetId, requestParameters.budget, options).then((request) => request(this.axios, this.basePath));
    }
}

